import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "task-progress-container" }
const _hoisted_2 = { class: "task-progress flex-center" }
const _hoisted_3 = {
  key: 2,
  class: "icon-uncheck-circle"
}
const _hoisted_4 = {
  key: 2,
  class: "icon-uncheck-circle"
}
const _hoisted_5 = {
  key: 2,
  class: "icon-uncheck-circle"
}
const _hoisted_6 = {
  key: 2,
  class: "icon-uncheck-circle"
}
const _hoisted_7 = {
  key: 2,
  class: "icon-uncheck-circle"
}
const _hoisted_8 = {
  key: 2,
  class: "icon-uncheck-circle"
}
const _hoisted_9 = {
  key: 2,
  class: "icon-uncheck-circle"
}

import { onMounted, ref } from "vue";
import { CheckCircleFilled, LoadingOutlined } from "@ant-design/icons-vue";
import { ITaskProgress } from "@/type/examManage";
import { useRouter, useRoute } from "vue-router";
import { request } from "@/services";

export default /*@__PURE__*/_defineComponent({
  __name: 'TaskProgress',
  props: {
  current: {
    type: Number,
    default: 1,
  },
  taskName: {
    type: String,
    default: "",
  },
},
  emits: ["update:taskName"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const router = useRouter();
const route = useRoute();
const props = __props;
const taskInfo = ref<ITaskProgress>();
const taskName = ref("");
const gradeCode = ref("");
const stepLoadingStates = ref<boolean[]>([false, false, false, false, false, false, false]);
const linkTo = (status: number) => {
  const path = ["TikaSetting", "MarkSetting", "TemplateMaking", "PaperScanContainer", "ProgressMonitoring", "ExceptionHandling", "ScoreRelease"];
  const routeMap: Record<number, string> = {
    0: "TikaSetting",
    1: "MarkSetting",
    2: "TemplateMaking",
    3: "PaperScanContainer",
    4: "ProgressMonitoring",
    5: "ExceptionHandling",
    6: "ScoreRelease"
  };
  router.push({
    name: routeMap[status],
    params: { taskId: taskInfo.value?.taskId, taskName: encodeURIComponent(taskName.value || '') },
    state: { ...history.state, subjectId: history.state.subjectId, createId: history.state.createId || taskInfo.value?.createId, gradeCode: gradeCode.value },
  });
};
const getTaskInfo = () => {
  request.get("/task/get-task-info", { params: { taskId: route.params.taskId.toString() } }).then((res) => {
    if (res.code === 200) {
      taskName.value = res.data.name;
      gradeCode.value = res.data.gradeCode;
    }
  });
};
// 防止重复调用标志
const isLoadingTaskProgress = ref(false);

const getTaskProgress = () => {
  // 防重复调用
  if (isLoadingTaskProgress.value) {
    return;
  }

  // 检查必需参数
  const taskId = route.params.taskId?.toString();
  if (!taskId) {
    return;
  }

  isLoadingTaskProgress.value = true;
  
  // 步骤映射：step索引映射到状态字段名
  const stepMapping = {
    0: 'tkState',
    1: 'yjState',
    2: 'mbzzState',
    3: 'djsmState',
    4: 'jdjkState',
    5: 'ycclState',
    6: 'cjfbState'
  };

  // 设置所有步骤为loading状态
  stepLoadingStates.value = [true, true, true, true, true, true, true];

  // 初始化taskInfo对象
  if (!taskInfo.value) {
    taskInfo.value = {} as ITaskProgress;
  }

  // 先异步调用 common/get-notice（不阻塞步骤状态请求）
  request.get("/common/get-notice")
    .then(() => {
      // common/get-notice 请求成功
    })
    .catch(() => {
      // common/get-notice 请求失败
    });

  // 创建7个步骤状态请求
  const stepRequests = [];
  for (let step = 0; step < 7; step++) {
    stepRequests.push(
      request.get("/task/get-task-step-state", { 
        params: { 
          taskId: taskId, 
          step: step 
        } 
      })
    );
  }
  
  // 执行步骤状态请求
  Promise.allSettled(stepRequests)
    .then((results) => {
      // 处理每个步骤状态请求结果
      results.forEach((result, index) => {
        const stepIndex = index; // 步骤索引（0-6）
        
        // 清除对应步骤的loading状态
        stepLoadingStates.value[stepIndex] = false;
        
        if (result.status === 'fulfilled' && result.value.code === 200) {
          // 请求成功，更新对应的状态字段
          const stateField = stepMapping[stepIndex as keyof typeof stepMapping];
          if (taskInfo.value && stateField) {
            (taskInfo.value as any)[stateField] = result.value.data;
          }
        }
      });
      
      // 发出更新事件
      emit("update:taskName", taskName.value);
      
    })
    .catch(() => {
      // 清除所有loading状态
      stepLoadingStates.value = [false, false, false, false, false, false, false];
    })
    .finally(() => {
      isLoadingTaskProgress.value = false;
    });
};
onMounted(() => {
  getTaskInfo();
  getTaskProgress();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["task-progress-item pointer", { active: taskInfo.value?.tkState, current: props.current == 1 }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (linkTo(0)))
      }, [
        (stepLoadingStates.value[0])
          ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
              key: 0,
              class: "icon-loading"
            }))
          : (taskInfo.value?.tkState)
            ? (_openBlock(), _createBlock(_unref(CheckCircleFilled), {
                key: 1,
                class: "icon-check-circle"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_3)),
        _cache[7] || (_cache[7] = _createTextVNode(" 题卡设置 "))
      ], 2),
      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "task-progress-arrow" }, "→", -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["task-progress-item pointer", { active: taskInfo.value?.yjState, current: props.current == 2 }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (linkTo(1)))
      }, [
        (stepLoadingStates.value[1])
          ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
              key: 0,
              class: "icon-loading"
            }))
          : (taskInfo.value?.yjState)
            ? (_openBlock(), _createBlock(_unref(CheckCircleFilled), {
                key: 1,
                class: "icon-check-circle"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_4)),
        _cache[8] || (_cache[8] = _createTextVNode(" 阅卷设置 "))
      ], 2),
      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "task-progress-arrow" }, "→", -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["task-progress-item pointer", { active: taskInfo.value?.mbzzState, current: props.current == 3 }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (linkTo(2)))
      }, [
        (stepLoadingStates.value[2])
          ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
              key: 0,
              class: "icon-loading"
            }))
          : (taskInfo.value?.mbzzState)
            ? (_openBlock(), _createBlock(_unref(CheckCircleFilled), {
                key: 1,
                class: "icon-check-circle"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_5)),
        _cache[9] || (_cache[9] = _createTextVNode(" 模板制作 "))
      ], 2),
      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "task-progress-arrow" }, "→", -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["task-progress-item pointer", { active: taskInfo.value?.djsmState, current: props.current == 4 }]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (linkTo(3)))
      }, [
        (stepLoadingStates.value[3])
          ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
              key: 0,
              class: "icon-loading"
            }))
          : (taskInfo.value?.djsmState)
            ? (_openBlock(), _createBlock(_unref(CheckCircleFilled), {
                key: 1,
                class: "icon-check-circle"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_6)),
        _cache[10] || (_cache[10] = _createTextVNode(" 答卷扫描 "))
      ], 2),
      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "task-progress-arrow" }, "→", -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["task-progress-item pointer", { active: taskInfo.value?.jdjkState, current: props.current == 5 }]),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (linkTo(4)))
      }, [
        (stepLoadingStates.value[4])
          ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
              key: 0,
              class: "icon-loading"
            }))
          : (taskInfo.value?.jdjkState)
            ? (_openBlock(), _createBlock(_unref(CheckCircleFilled), {
                key: 1,
                class: "icon-check-circle"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_7)),
        _cache[11] || (_cache[11] = _createTextVNode(" 进度监控 "))
      ], 2),
      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "task-progress-arrow" }, "→", -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["task-progress-item pointer", { active: taskInfo.value?.ycclState, current: props.current == 6 }]),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (linkTo(5)))
      }, [
        (stepLoadingStates.value[5])
          ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
              key: 0,
              class: "icon-loading"
            }))
          : (taskInfo.value?.ycclState)
            ? (_openBlock(), _createBlock(_unref(CheckCircleFilled), {
                key: 1,
                class: "icon-check-circle"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_8)),
        _cache[12] || (_cache[12] = _createTextVNode(" 异常处理 "))
      ], 2),
      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "task-progress-arrow" }, "→", -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["task-progress-item pointer", { active: taskInfo.value?.cjfbState, current: props.current == 7 }]),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (linkTo(6)))
      }, [
        (stepLoadingStates.value[6])
          ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
              key: 0,
              class: "icon-loading"
            }))
          : (taskInfo.value?.cjfbState)
            ? (_openBlock(), _createBlock(_unref(CheckCircleFilled), {
                key: 1,
                class: "icon-check-circle"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_9)),
        _cache[13] || (_cache[13] = _createTextVNode(" 成绩发布 "))
      ], 2)
    ])
  ]))
}
}

})